export default __webpack_public_path__ + "8f7b471e99f6a5d71cd6dd2d3ec1ae9a.png";